/*
 * Copyright (c) 2018 Barclays PLC.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Barclays PLC.
 * ("Confidential Information").
 *
 * File: prospectForm.js
 * Created: Oct 25, 2018
 */

import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Input from '../../Forms/Input/input';
import { toNumber } from '../../../utils/formatters';
import { required, alphaName, notEmpty } from '../../../utils/validate';
import { toAlphabets } from '../../../utils/formatters';
import { submitInvitationCode, toggleNoInvitationDialog } from '../../../actions/loanApplicationActions';
import PropTypes from 'prop-types';
import '../applicationForm.scss';
import FeatureToggle from '../../FeatureToggle/feature.toggle';

export const ProspectForm = (props) => {
  const { handleSubmit, submitInvitationCode, submitSucceeded, toggleNoInvitationDialog } = props;
  if (submitSucceeded) {
    return <Redirect push to="/apply/loan/check-your-rate"/>;
  }

  return (
    <section className="cyr-step prospect">
      <header>
        <h1 className="grey-text get-started">Get Started</h1>
        <h2 className="cyr-step-header-text">Let's check your loan rate.</h2>
        <h3 className="subtext grey-text text-center">
          This will take just a few minutes.
        </h3>
      </header>

      <form onSubmit={handleSubmit(submitInvitationCode)} noValidate={true} autoComplete="off" className="prospect-form application-form">
        <Field
          name="invitationCode"
          label="Invitation code"
          component={Input}
          type="text"
          validate={[required]}
          required={true}
          normalize={toNumber}
          autoFocus={true}
        />
        <Field
          name="lastName"
          label="Last name"
          component={Input}
          type="text"
          validate={[required, alphaName, notEmpty]}
          required={true}
          normalize={toAlphabets}
        />
        <p>
          <button type="submit" formNoValidate="true">Continue</button>
        </p>
      </form>

      <footer>
        <p>
          <i className="material-icons">thumb_up</i> Checking your rate won't affect your credit score.
        </p>
        <FeatureToggle key="toggleOff" featureName="cl_block_open_market" showWhenFeatureToggleOff={true}>
          <Link to="/clapply/cl/CLLanding.action" data-track="app-links">No invitation code?</Link>
        </FeatureToggle>
        <FeatureToggle key="toggleOn" featureName="cl_block_open_market">
          <Link to="/" data-track="app-links" onClick={toggleNoInvitationDialog}> No invitation code? </Link>
        </FeatureToggle>
      </footer>
    </section>
  );
};

ProspectForm.propTypes = {
  submitInvitationCode: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitSucceeded: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = { submitInvitationCode, toggleNoInvitationDialog };
export const ConnectedProspectForm = connect(mapStateToProps, mapDispatchToProps)(ProspectForm);

export default reduxForm({
  form: 'prospectForm'
})(ConnectedProspectForm);
